<template>
  <div>
    <v-card flat>
      <v-card-title>
        <h1 class="primary--text px-5 font-weight-bold info-page-title ma-auto">{{ $t(`label.aboutUs`) }}</h1>
      </v-card-title>
    </v-card>

    <v-card class="info-page-card">
      <v-expansion-panels accordion v-model="panel">
        <v-expansion-panel v-for="info in aboutUsContent" :key="info.title">
          <v-expansion-panel-header class="font-weight-bold text-uppercase">{{ info.title }}</v-expansion-panel-header>
          <v-expansion-panel-content class="py-4 info-expension-panel-content">
            <div v-for="content in info.content" :key="content.title">
              <p class="text-capitalize font-weight-bold info-expension-panel-content-title mb-1" v-html="content.title"></p>
              <p v-html="content.desc"></p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import {locale, uiHelper} from '@/util'
export default {
  name: 'aboutUs',
  data: () => ({
    panel: 0,
    aboutUsContent: [
      {
        title: locale.getMessage(`info.info_aboutUs`),
        content: [
          {
            title: locale.getMessage(`info.info_aboutUs_a_title`),
            desc: locale.getMessage(`info.info_aboutUs_a_desc`)
          },
          {
            title: locale.getMessage(`info.info_aboutUs_b_title`),
            desc: locale.getMessage(`info.info_aboutUs_b_desc`)
          },
          {
            title: locale.getMessage(`info.info_aboutUs_c_title`),
            desc: locale.getMessage(`info.info_aboutUs_c_desc`)
          },
          {
            title: locale.getMessage(`info.info_aboutUs_d_title`),
            desc: locale.getMessage(`info.info_aboutUs_d_desc`)
          },
          {
            title: locale.getMessage(`info.info_aboutUs_e_title`),
            desc: locale.getMessage(`info.info_aboutUs_e_desc`)
          }
        ]
      }
    ]
  }),
  methods: {
    metaTag() {
      uiHelper.setTitle(`${locale.getMessage('meta.aboutUs_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.aboutUs_description')}`)
    },
  },
  created() {
    this.metaTag()
  },
}
</script>
